// ======================================================================
// File Name       : ContentBigQuestionConfirmDialog
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import React from 'react';
import { Col, Button, Modal } from 'react-bootstrap';
import { SELECT_BOX_DATA } from '../../constants/SelectBoxData';
import { MODAL_SIZE } from '../../constants/index';
import ContentQuestionDetail from './ContentQuestionDetail';

const ContentBigQuestionConfirmDialog = (props) => {
  const style = {
    background: 'none',
    width: 'auto',
    marginLeft: 0,
    left: 0,
  };
  const {
    showModal,
    questionKind,
    questionSecernId,
    questionTitle,
    subQuestionArray,
    limitTime,
    onOkClick,
    onCancelClick,
    questionZipFileName,
    questionUseForm,
    explanationUse,
    explanationHtmlUse,
    explanationContent,
    explanationZipFileName,
    hintUse,
    hintHtmlUse,
    hintContent,
    hintZipFileName,
    questionAttributeList,
  } = props;
  const getQuestionKindText = (kindNum) => {
    try {
      const convertedValue = parseInt(kindNum, 10);
      return SELECT_BOX_DATA.QUESTION_TYPE.filter(item => item.value === convertedValue)[0].name;
    } catch (error) {
      return kindNum;
    }
  };
  return (
    <Modal
      show={props.showModal}
      size={MODAL_SIZE.lg}
      style={style}
    >
      <Modal.Header onHide={props.onCancel} closeButton>
        <Modal.Title className="text-center">
          以下の内容で登録します
        </Modal.Title>
      </Modal.Header>

      <Modal.Body className="margin-10">
        <Col sm={12}>
          <ContentQuestionDetail
            questionKind={parseInt(questionKind, 10)}
            questionSecernId={questionSecernId}
            questionTitle={questionTitle}
            subQuestionArray={subQuestionArray}
            sankakuUseDistinct={1}
            limitTime={limitTime}
            isDetail={false}
            questionZipFileName={questionZipFileName}
            questionUseForm={1}
            explanationUse={explanationUse}
            explanationContent={explanationContent}
            explanationHtmlUse={explanationHtmlUse}
            explanationZipFileName={explanationZipFileName}
            hintUse={hintUse}
            hintHtmlUse={hintHtmlUse}
            hintContent={hintContent}
            hintZipFileName={hintZipFileName}
            questionAttributeList={questionAttributeList}
          />
        </Col>
      </Modal.Body>
      <Modal.Footer className="text-center">
        <Button key={0} variant="default" className="btn-96" onClick={onCancelClick}>
          {'キャンセル'}
        </Button>
        <Button key={1} className="btn-96" variant="primary" onClick={onOkClick}>
          {'OK'}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ContentBigQuestionConfirmDialog;
